import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'privacy-preferences';

export default {
    ...dynaForms.getTypes(storeName),
    RESET_DATA: `${storeName}.RESET_DATA`,
    SET_PREFERENCES: `${storeName}.SET_PREFERENCES`,
    DO_SUBMIT: `${storeName}.DO_SUBMIT`,
    SET_PREFERENCE_GROUPS: `${storeName}.SET_PREFERENCE_GROUPS`,
    SET_OTHER_GROUP: `${storeName}.SET_OTHER_GROUP`,
    SET_CONSENT_TEMPLATES: `${storeName}.SET_CONSENT_TEMPLATES`,
    SUBMIT_CURRENT_PREFERENCE: `${storeName}.SUBMIT_CURRENT_PREFERENCE`,
};
